module.exports = __webpack_public_path__ + "img/CMEF-qingdao.2accfaae.png";